'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Embed = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Embed = exports.Embed = (0, _systemComponents2.default)({
  ratio: 9 / 16
}, 'ratio', 'space', 'color', function (props) {
  return {
    position: 'relative',
    overflow: 'hidden',
    '& > iframe': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      bottom: 0,
      left: 0,
      border: 0
    }
  };
});

Embed.displayName = 'Embed';

exports.default = Embed;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Embed.js
// module id = 501
// module chunks = 168707334958949